// @ts-strict-ignore
import { UserVO } from '@user/model/vo/user.vo';
import { ArticleVO } from '@article/model/vo/article.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('CustomArticleInfoVO')
export class CustomArticleInfoVO {
  @JsonProperty('id', 'Number')
  public id: number | undefined = undefined;

  @JsonProperty('userId', 'Number')
  public userId: number = undefined;

  @JsonProperty('articleNumber', 'String')
  public articleNumber: string = undefined;

  @JsonProperty('articleDescription', 'String')
  public articleDescription: string = undefined;

  @JsonProperty('articleWidth', 'Number')
  public articleWidth: number = undefined;

  @JsonProperty('articleHeight', 'Number')
  public articleHeight: number = undefined;

  @JsonProperty('articleDepth', 'Number')
  public articleDepth: number = undefined;

  @JsonProperty('articleDepthOffset', 'Number')
  public articleDepthOffset: number = undefined;

  @JsonProperty('imageHash', 'String')
  public imageHash: string | undefined = undefined;
}

@JsonObject('CustomArticleLibraryVO')
export class CustomArticleLibraryVO {
  @JsonProperty('user', 'UserVO')
  public user: UserVO = undefined;

  @JsonProperty('customArticleInfos', '[CustomArticleInfoVO]')
  public customArticleInfos: CustomArticleInfoVO[] = [];
}

@JsonObject('CustomImageDataVO')
export class CustomImageDataVO {
  @JsonProperty('userId', 'Number')
  public userId: number = undefined;

  @JsonProperty('imageData', 'Object')
  public imageData: any = undefined;

  @JsonProperty('imageType', 'String')
  public imageType: string = undefined;

  public isValidImage() {
    return this.isValidImageType() && this.isValidBase64ImageData();
  }

  private isValidBase64ImageData(): boolean {
    const base64Pattern = /^[A-Za-z0-9+/=]+$/;
    return base64Pattern.test(this.imageData);
  }

  private isValidImageType(): boolean {
    const validTypes = ["png", "jpeg", "jpg"];
    return validTypes.includes(this.imageType);
  }
}

@JsonObject('CustomArticleVO')
export class CustomArticleVO extends ArticleVO {

  public static readonly CLASS_NAME: string = 'CustomArticleVO';

  @JsonProperty('customArticleInfo', 'CustomArticleInfoVO')
  public customArticleInfo: CustomArticleInfoVO = undefined;

  @JsonProperty('customImageData', 'Object')
  public customImageData: any = undefined;

  public constructor() {
    super();
    this.classType = CustomArticleVO.CLASS_NAME;
  }
}

@JsonObject('SaveCustomArticleRequestVO')
export class SaveCustomArticleRequestVO {
  @JsonProperty('articleInfo', 'CustomArticleInfoVO')
  public articleInfo: CustomArticleInfoVO = undefined;

  @JsonProperty('imageData', 'CustomImageDataVO')
  public imageData?: CustomImageDataVO = undefined;
}
